<template>
	<div v-loading.fullscreen.lock="loadingSave" :element-loading-text="'Processando...'+(requestParam.uploadProgress != null ? '\n'+requestParam.uploadProgress+'%' : '')">
		<ed-modal 
			:title="formData.id == 0 ? 'Novo Anexo' : 'Editar Anexo'" 
			:modal="showFormEdit" 
			:loadingSave="loadingSave"
			:onSave="salvar"
			width="80%"
		>
			<div slot="modal-content" v-loading="config.loading.content">
				<ed-form :data="formData" :config="config" :response="response" :itens="exameItems">
					<div slot="form-footer"></div>
				</ed-form>
				<ed-alert 
					v-if="formData.id == 0"
					title="Instruções"
					type="warning"
				>
					<div slot="description">
						<ul>
							<li>O arquivo não deve exceder 50MB de tamanho</li>
							<li>Os formatos dos arquivos devem estar em PDF, ZIP, JPG, PNG ou JPEG</li>
							<li>Todos o arquivos enviados que não corresponderem a uma IMAGEM, serão convertidos em IMAGEM automaticamente.</li>
							<li>Só é possível enviar 1 arquivo por vez. Se precisar enviar vários arquivos, você deve compactar os mesmo no formato ZIP e envia-los. Assim o sistema consegue desconpactar e salvar corretamente no servidor.</li>
						</ul>
					</div>
				</ed-alert>
			</div>
		</ed-modal>
	</div>
</template>

<script>

	import Rest from 'common/rest';
	import EdForm from 'common/form';
	import EdModal from 'common/modal';
	import EdAlert from 'common/alert';
	import FormItems  from './_form/equipamento-cadastrar';

  	export default {
  		name:"exame-editar",
  		components: {EdForm,EdModal,EdAlert},
		mixins:[Rest],
		props:{
            anexo:{
                type: Object,
                default: function(){
					return {
						id:0,
						descricao:null,
						arquivo:null,
						updated_at:null,
						usuario:null,
						ativo:1
					};
				}
			},
			parent:{
                type: Object,
                default: null
			},
			showForm:{
				type: Boolean,
                default: false
			}
        },
		watch: {
			'anexo.id'(){
			},
			showForm(){
				this.showFormEdit = !this.showFormEdit;
				this.init();
				if(this.anexo.id != 0){
					this.getAnexo();
				}
			},
		},
  		data () {
		   	return {
				config:{
					tipo:[],
					loading:{
						save:false,
						content:false,
					},
					list:{
					}
				},
		   		formData:{
		   			id:0,
		   			descricao:null,
					arquivo:null,
		   			updated_at:null,
					usuario:null,
		   		},
				response:{},
				exameItems:[],
				loadingSave:false,
				showFormEdit:false,
			}
		},

		mounted() {
			this.exameItems = FormItems;

			this.$events.on('upload-arquivo', eventData => {
				this.formData.arquivo = eventData;
			});

			this.$events.on('upload-arquivo-delete', eventData => {
				this.getAnexo();
			});

			this.$events.on('onClienteEvent', eventData => {
				this.parent.getLtcatAnexo();
	        });
		},

		methods: {

			init(){
				this.formData = {
					id:0,
		   			descricao:null,
					arquivo:null,
		   			updated_at:null,
					usuario:null,
					ativo:1
				};
			},
			
			getAnexo(){

				this.config.loading.content = true;
				this.formData = {};

				this.get('ltcat/anexo/'+this.parent.ltcat.id+'/'+this.anexo.id).then((result)=>{

		            result = result[0];

		            this.config.loading.content = false;

		            if(result.status == 200){
						this.formataData(result);
		            }
		        });
			},

			formataData(result){
				this.formData = {
					id:result.data.id,
					descricao:result.data.descricao,
					arquivo:result.data.arquivo,
					usuario:result.data.usuario,
					updated_at:result.data.updated_at,
				};
			},

			salvar(){

				this.response = {};
				this.loadingSave = true;

				this.post('/ltcat/anexo/'+this.parent.ltcat.id+'/editar',this.toFormUpload(this.formData)).then((result)=>{

					result = result[0];

					this.loadingSave = false;
					this.response = result;

					if(result.status == 200){
						this.edMsg('Registro salvo com sucesso!');
						this.formataData(result);
						this.showFormEdit = !this.showFormEdit;

						if(this.parent.getLtcatAnexo)
							this.parent.getLtcatAnexo();
					}

				});
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// editar.vue?08db33ed